import { useEffect, useState } from "react";
import { Pause } from "lucide-react";
import { useStore, stopTimer, spentSecFor } from "@/lib/store";

function fmt(sec) {
  const s = Math.max(0, Math.floor(sec));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const ss = s % 60;
  if (h > 0) return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(ss).padStart(2, "0")}`;
  return `${String(m).padStart(2, "0")}:${String(ss).padStart(2, "0")}`;
}

export default function TimerBar() {
  const timer = useStore((s) => s.timer);
  const tasks = useStore((s) => s.tasks);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    if (!timer) return;
    const id = setInterval(() => setTick((n) => n + 1), 1000);
    return () => clearInterval(id);
  }, [timer]);

  if (!timer) return null;
  const task = tasks.find((t) => t.id === timer.taskId);
  if (!task) return null;
  const elapsed = spentSecFor(task, timer.date) + Math.floor((Date.now() - timer.startedAt) / 1000);

  return (
    <div className="tl-paper flex items-center justify-between px-5 py-3" data-testid="timer-bar" data-tick={tick}>
      <div className="flex items-center gap-3 min-w-0">
        <span className="tl-label text-[#8FA087]">In corso</span>
        <span className="text-[#3B443D] font-medium truncate">{task.title}</span>
      </div>
      <div className="flex items-center gap-3">
        <span className="font-serif-display font-semibold text-2xl text-[#3B443D] tabular-nums" data-testid="timer-display">{fmt(elapsed)}</span>
        <button
          type="button"
          onClick={stopTimer}
          className="tl-icon-btn p-2 rounded-full bg-white border border-[#E4E7E1] hover:bg-[#F3F5F0]"
          aria-label="Ferma cronometro"
          data-testid="timer-stop"
        >
          <Pause size={16} strokeWidth={1.75} />
        </button>
      </div>
    </div>
  );
}
